import { render, staticRenderFns } from "./RangeWithVariantsWidget.vue?vue&type=template&id=3f7ad5f7&lang=pug&"
import script from "./RangeWithVariantsWidget.vue?vue&type=script&lang=js&"
export * from "./RangeWithVariantsWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports